import {
    Grid,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableBody,
} from "@mui/material";
import React from "react";
import {
    BaseGrid,
    StyledTableRow,
    TableCellHeader,
    TableCellWidth,
    TitleTypography,
} from "../KandidatViewPage";
import {KontakDaruratByIDResponse} from "../../../models/KontakDarurat";

type Props = { data: KontakDaruratByIDResponse[] };

export default function DataKontakDaruratKandidatPage({ data }: Props) {
    return (
        <BaseGrid container item xs={12} justifyContent="center">
            <Grid
                container
                item
                xs={12}
                sx={{
                    backgroundColor: "#00ACED",
                    color: "#fff",
                    marginBottom: "4%",
                }}
            >
                <TitleTypography>Data Kontak Darurat Kandidat</TitleTypography>
            </Grid>
            <Grid container item xs={12}>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow
                                sx={{
                                    backgroundColor: "rgba(0,0,0,0.1)",
                                }}
                            >
                                <TableCellHeader>Nama</TableCellHeader>
                                <TableCellHeader>Telepon</TableCellHeader>
                                <TableCellHeader>Alamat</TableCellHeader>
                                <TableCellHeader>Hubungan</TableCellHeader>
                                <TableCellHeader>Pekerjaan</TableCellHeader>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row, key) => (
                                <StyledTableRow
                                    key={key}
                                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                    <TableCellWidth>{row.NAMA}</TableCellWidth>
                                    <TableCellWidth>{row.TELEPON}</TableCellWidth>
                                    <TableCellWidth>{row.ALAMAT}</TableCellWidth>
                                    <TableCellWidth>{row.HUBUNGAN}</TableCellWidth>
                                    <TableCellWidth>{row.PEKERJAAN}</TableCellWidth>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </BaseGrid>
    );
}
